import { render } from "./PersonalInformationStep.vue?vue&type=template&id=45bb3f0b"
import script from "./PersonalInformationStep.vue?vue&type=script&lang=js"
export * from "./PersonalInformationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__